import React from 'react'
import { motion } from "framer-motion";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";

export default function Eligibilityandoc() {
     const items = [
    { title: "Nationality", desc: "Must be an Indian resident." },
    { title: "Age", desc: "Typically between 21–55 years." },
    { title: "Employment Profile", desc: "Applicable for salaried professionals meeting eligibility criteria." },
    { title: "PAN Card", desc: "Valid PAN card required for verification." },
    { title: "Photograph", desc: "Application should include a recent photograph." },
    { title: "Monthly Income", desc: "Minimum monthly income of ₹30,000 may be required." },
    { title: "Bank Statements", desc: "Last 3 months’ salary account statements." },
    { title: "Savings Account", desc: "Active savings bank account required." },
    { title: "Salary Slips", desc: "Last 3 months’ salary slips may be required." }
  ];
  return (
     <section className="w-full py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-7xl mx-auto">

        {/* Header */}
        <motion.div
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          viewport={{ once: true }}
          className="rounded-xl p-6 mb-10 max-w-6xl "
        >
          <p className="text-orange-500 text-sm font-semibold mb-1">
            Eligibility Requirements
          </p>

          <h2 className="text-2xl sm:text-3xl font-bold text-gray-900 mb-2">
            Check Basic Eligibility Before Applying
          </h2>

          <p className="text-gray-600 text-sm sm:text-base">
           Instant loan eligibility may depend on profile verification, income details, employment information, and lender evaluation criteria. The following are general requirements for salaried professionals applying for an instant loan through B4Salary.
          </p>
        </motion.div>

        {/* Cards */}
        <motion.div
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true }}
          variants={{
            hidden: {},
            visible: {
              transition: {
                staggerChildren: 0.15,
              },
            },
          }}
          className="grid grid-cols-1 md:grid-cols-2 gap-6"
        >
          {items.map((item, index) => (
            <motion.div
              key={index}
              variants={{
                hidden: { opacity: 0, y: 30 },
                visible: { opacity: 1, y: 0 },
              }}
              className="flex items-start gap-4 bg-white rounded-lg p-5 shadow-sm hover:shadow-md transition"
            >
              {/* Icon */}
              <div className="w-10 h-10 flex items-center justify-center bg-orange-100 rounded-full">
                <CheckCircleIcon />
              </div>

              {/* Content */}
              <div>
                <h3 className="font-semibold text-gray-900 text-sm sm:text-base">
                  {item.title}
                </h3>
                <p className="text-gray-600 text-xs sm:text-sm">
                  {item.desc}
                </p>
              </div>
            </motion.div>
          ))}
        </motion.div>

      </div>
    </section>
  )
}
